mainApp.component('sitePopLocation',{
    templateUrl: '/public/components/site-pop-location.component.html',
    bindings: {
        region: '<',
        locations: '=',
        forceSelectedLocations: '=',
        numOfLocations: '<',
        siteId: '<',
        accountId: '<'
    },
    controller: sitePopLocationController
});

function sitePopLocationController($scope, $state, SitePopLocationService, GeneralUtilsService) {
    var ctrl = this;

    const autoName = 'Automatic (default)';
    const autoId = -1;
    const noneName = 'None';
    const noneId = -2;

    let originalLocations;

    ctrl.$onChanges = function(changes) {
        if (changes.region && changes.region.currentValue) {
            ctrl.setPops(changes.region.currentValue);
        }
        if (!changes.siteId) {
            for (let locationIdx = 0; locationIdx < ctrl.numOfLocations; locationIdx++) {
                if (ctrl.locations[locationIdx]){
                    let locationEntityId = ctrl.locations[locationIdx].id;
                    ctrl.locations[locationIdx] = {locationId: autoId, name: autoName, priority: locationIdx};
                    if (locationEntityId) {
                        ctrl.locations[locationIdx].id = locationEntityId;
                    }
                }
            }
        }
        originalLocations = angular.copy(ctrl.locations);
        ctrl.onChange(0);
    };

    ctrl.setPops = function(newRegion) {
        SitePopLocationService.getPops(newRegion, ctrl.accountId, function(data) {
            data.pops.sort((pop1, pop2) => (pop1.name > pop2.name) ? 1 : -1);
            data.pops.unshift({id: autoId, name: autoName});
            ctrl.pops = data.pops.slice();
            data.pops.unshift({id: noneId, name: noneName});
            ctrl.popsWithNone = data.pops.slice();
            $scope.$digest();
        });
    };

    ctrl.getPops = function(n) {
        return (n === 0) ? ctrl.pops : ctrl.popsWithNone;
    }

    ctrl.onChange = function(index) {
        ctrl.setPriority(index);
        ctrl.enableDisable(index, ctrl.locations[index].locationId);
        ctrl.resetForce(index);
    }

    ctrl.resetForce = function(index) {
        if (ctrl.isAuto) {
            ctrl.forceSelectedLocations = false;
        }
    }

    ctrl.setPriority = function(priority) {
        if (!ctrl.locations[priority].priority) {
            ctrl.locations[priority].priority = priority;
        }

        // if only the first location exists (in the DB) then new locations won't be able to be saved if they don't have an ID
        // (because selection name is the same for all priorities, and we compare either by ID or by name)
        if (ctrl.locations[0].id > 0) {
            if (!ctrl.locations[priority].id) {
                ctrl.locations[priority].id = -1;
            }
            else if (ctrl.locations[priority].locationId === -1 && ctrl.locations[priority].id === -1 && originalLocations[priority].id === undefined) {
                // this location was changed and reverted (back to automatic) before save, we don't want to generate a false audit so we revert back the id
                delete ctrl.locations[priority].id;
            }
        }

    }

    ctrl.enableDisable = function(index, popId) {
        if (popId === autoId) {
            ctrl.autoIndex = index;
        } else if (ctrl.locations) {
            let idx = ctrl.locations.findIndex(function(element) {
                return element.locationId === autoId;
            });
            ctrl.autoIndex = idx;
        }
        ctrl.isAuto = ctrl.autoIndex !== -1;
    }
}
